import { FullstateToAbvPipe } from '../../../../../../_helpers/_pipes/fullstate-to-abv.pipe';
import { FormatPhonePipe } from '../../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { UploadTypeModalComponent } from '../../../../../screens/upload-type-modal/upload-type-modal.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { SystemMaintenanceComponent } from '../../../../../screens/system-maintenance/system-maintenance.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CompanyTypeService } from '../../../../../../_services/_iam/company-type.service';
import {
  ValidateAddressService,
  GetGooglePlaceService,
  AlertService,
  ModalOptions,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { AddressService } from '../../../../../../_services/change-address/validate-address.service';
import { Router , RouterModule } from '@angular/router';
import { ChangeAddressService } from '../../../../../../_services/change-address/change-address.service';
import { StorageServiceObservablesService } from '@services/storage-service-observables/storage-service-observables.service';
import { PaperlessService } from '../../../../../../_services/_iam/paperless.service';
import { ErrorRedirectionService } from '../../../../../../_services/error-service/error-redirection.service';
import { PolicyDataService } from '../../../../../../_services/data-services/policy-data.service';
import { PolicyDetailsService } from '../../../../../../_services/my-insurance/policy-details.service';
import { EnrollEftEpayService } from '../../../../../../_services/forms/enroll-eft-epay/enroll-eft-epay.service';
import { FlagResponse } from '@models/flag-response';
import { FlagDataService } from '../../../../../../_services/data-services/flag-data.service';
import { Constants } from '@models/constants';
import { PolicyBillingUploadService } from '@services/policy-billing-upload.service';
import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, SystemMaintenanceComponent, MapfreButtonComponent, UploadTypeModalComponent, FormatPhonePipe, FullstateToAbvPipe],
  selector: 'app-details-sidebar',
  templateUrl: './details-sidebar.component.html',
  styleUrls: ['./details-sidebar.component.scss'],
})
export class DetailsSidebarComponent implements OnInit {
  @Input() policy: any;
  @Output() showToast: EventEmitter<any> = new EventEmitter<any>();
  @Output() showMileageToast: EventEmitter<any> = new EventEmitter<any>();

  effeDate: any;
  todayDate: any;
  isItTheSameAddress: boolean;
  policyId: any;
  fullCoverage: any;
  unEnrollModalOptions: ModalOptions;
  hideModal: boolean;
  autoPay: any = false;
  isAutoPay: any;
  isPaperless: any;
  showMessage: boolean;
  isAcmic: boolean;
  company: any;
  isEligibleForUpload: boolean;
  aptResidentialNumber: string;
  aptMailingNumber: string;
  residentialStreetName: any;
  mailingStreetName: any;

  constructor(
    private validateAddressService: ValidateAddressService,
    private googlePlaceService: GetGooglePlaceService,
    private addressService: AddressService,
    public router: Router,
    public alertService: AlertService,
    private changeAddressService: ChangeAddressService,
    private storageServiceObservablesService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private errorRedirectionService: ErrorRedirectionService,
    private policyDataService: PolicyDataService,
    private policyDetailsService: PolicyDetailsService,
    private enrollEftEpayService: EnrollEftEpayService,
    private flagDataService: FlagDataService,
    private acmicService: AcmicService,
    private companyTypeService: CompanyTypeService,
    private pbUploadService: PolicyBillingUploadService,
    private dataLayer:DataLayerService
  ) {
    this.unEnrollModalOptions = new ModalOptions({
      additionalClasses: 'modal-medium cancel-enroll modal-dialog',
      additionalButtonClasses:
        'red-text float-right align-middle flat no-padding no-margin col-auto cross-btn-class',
      animatePosition: 'top',
      buttonCopy: 'MODAL_REMOVAL_TITLE',
      modalId: 'unEnrollModal',
      howManyIconsUsed: 1,
      iconClasses: 'far fa-times-circle',
      modalTranslateCopy: 'MODAL_REMOVAL_TITLE',
      screenReader: true,
      showIcons: true,
      modalName: 'detail-sidebar_unEnroll',
    });
    this.detectStateCode();
    this.isEligibleForUpload = false;
  }

  detectStateCode() {
    this.isAcmic = this.acmicService.isACMIC();
  }

  closeModal() {
    this.showMessage = false;
  }

  onShowMessage() {
    this.showMessage = true;
  }

  ngOnInit() {
    this.isEligibleForUpload = this.pbUploadService.isMAGWPolicy(this.policy);
    this.todayDate = new Date();

    this.flagDataService.$flagDeatils.subscribe((response: FlagResponse) => {
      if (response) {
        this.isPaperless = response.paper;
        this.isAutoPay = response.eft;
      }
    });

    if (this.policy) {
      this.effeDate = new Date(this.policy.effDate);
    }

    // Remove hyphens from agent phone number
    if (this.policy.agent && this.policy.agent.agentPhone) {
      this.policy.agent.agentPhone.number =
        this.policy.agent.agentPhone && this.policy.agent.agentPhone.number
          ? this.policy.agent.agentPhone.number.replace(/-/g, '')
          : '';
    }

    // Remove hyphens from agent ISC phone number
    if (this.policy.agent && this.policy.agent.agentISCPhone) {
      this.policy.agent.agentISCPhone.number =
        this.policy.agent.agentISCPhone &&
        this.policy.agent.agentISCPhone.number
          ? this.policy.agent.agentISCPhone.number.replace(/-/g, '')
          : '';
    }

    this.policyId = this.policy.policynumber.policyNumber;
    if(this.policyId != null){
      this.company = this.companyTypeService.getCompany(this.policyId);
    }
    
    if (this.policyId.length === 10) {
      // Code for get updated address
      const serviceAddress = this.addressService.getAddress();
      if (serviceAddress && serviceAddress.policyid === this.policyId) {
        const address = {
          streetName: serviceAddress.streetName,
          city: serviceAddress.city,
          state: serviceAddress.state,
          stateCode: serviceAddress.state,
          zipCode: {
            code: serviceAddress.zipCode.code,
          },
        };

        if (
          this.changeAddressService.getIsResidentialAddressUpdated() &&
          this.changeAddressService.getIsMailingAddressUpdated()
        ) {
          this.policy.residentialAddress = address;
          this.policy.mailingAddress = address;
        } else if (this.changeAddressService.getIsResidentialAddressUpdated()) {
          this.policy.residentialAddress = address;
        } else if (this.changeAddressService.getIsMailingAddressUpdated()) {
          this.policy.mailingAddress = address;
        }

        this.changeAddressService.setIsResidentialAddressUpdated(false);
        this.changeAddressService.setIsMailingAddressUpdated(false);

        serviceAddress.streetName =
          serviceAddress.streetName && serviceAddress.streetName != ''
            ? serviceAddress.streetName.trim()
            : serviceAddress.streetName;
        const FinaladdressStr =
          serviceAddress.streetName +
          ',' +
          serviceAddress.city +
          ',' +
          serviceAddress.state +
          ',' +
          'USA';
        this.validateAddressService.updateAddress(FinaladdressStr);
        this.googlePlaceService.updateAddress(FinaladdressStr);
      }
      this.detectStateCode();
      if (this.isAcmic && this.policy.residentialAddress?.streetName?.includes('#')) {
        this.residentialStreetName = this.policy.residentialAddress.streetName?.split('#')[0]
        this.aptResidentialNumber = this.policy.residentialAddress.streetName?.split('#')[1];
      }
      if (this.isAcmic && this.policy.mailingAddress?.streetName?.includes('#')) {
        this.mailingStreetName = this.policy.mailingAddress.streetName?.split('#')[0];
        this.aptMailingNumber = this.policy.mailingAddress.streetName?.split('#')[1];

      }
    }

    this.isAddressEqual(this.policy);
    const { effDate } = this.policy;
    if (effDate) {
      this.autoPay = this.policyDetailsService.getDayDifference(effDate);
    }
  }
   triggerDatalayer(label:string){
    const event={
        name:'click_link',
        category:'remarked content',
        detail:'manage policy',
        label:label
      }
       this.dataLayer.pushEvent(event);
      console.log(event)
  }

  isAddressEqual(policyDetail): void {
    let address;
    if (
      policyDetail.mailingAddress.streetName.toLowerCase() ==
        policyDetail.residentialAddress.streetName.toLowerCase() &&
      policyDetail.mailingAddress.city.toLowerCase() ==
        policyDetail.residentialAddress.city.toLowerCase() &&
      policyDetail.mailingAddress.stateCode.toLowerCase() ==
        policyDetail.residentialAddress.stateCode.toLowerCase() &&
      policyDetail.mailingAddress.zipCode.code.toLowerCase() ==
        policyDetail.residentialAddress.zipCode.code.toLowerCase()
    ) {
      address = true;
    } else {
      address = false;
    }
    this.isItTheSameAddress = address;
  }

  checkForFullCoverage(): void {
    const policyFlags = this.policy.policyFlags;
    let isItFullCoverage;

    if (policyFlags.length == 0) {
      isItFullCoverage = false;
    } else {
      if (this.policy.policyType == 'HOME') {
        if (
          policyFlags.isEbill == Constants.UNENROLLED ||
          policyFlags.isEbill == 'N' ||
          policyFlags.isEdf == Constants.UNENROLLED ||
          policyFlags.isEft == Constants.UNENROLLED
        ) {
          isItFullCoverage = false;
        } else {
          isItFullCoverage = true;
        }
      } else if (this.policy.policyType == 'AUTO') {
        if (
          (policyFlags.isEbill == Constants.ENROLLED ||
            policyFlags.isEbill == 'Y' ||
            policyFlags.isEbill == Constants.ENROLLMENT_PENDING) &&
          (policyFlags.isEdf == Constants.ENROLLED ||
            policyFlags.isEdf == Constants.ENROLLMENT_PENDING)
        ) {
          isItFullCoverage = true;
        } else if (
          (policyFlags.isEdf == Constants.ENROLLED ||
            policyFlags.isEdf == Constants.ENROLLMENT_PENDING) &&
          (policyFlags.isEft == Constants.ENROLLED ||
            policyFlags.isEft == Constants.ENROLLMENT_PENDING)
        ) {
          isItFullCoverage = true;
        } else {
          isItFullCoverage = false;
        }
      }
    }
    this.fullCoverage = isItFullCoverage;
  }

  getMailingOrResidentialAddress(updateAddress, addresType, policyId) {
    if (
      (this.policy &&
        this.policy['days_left_to_expire'] &&
        this.policy['days_left_to_expire'] <= 30 &&
        this.policy.policynumber.policyNumber.length === 6 &&
        this.policy.livoPolicy) ||
      this.policy['isNewPolicy']
    ) {
      this.showMileageToast.emit(true);
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
    } else {
      const address = {
        streetName: updateAddress.streetName,
        city: updateAddress.city,
        state: updateAddress.stateCode,
        zipCode: {
          code: updateAddress.zipCode.code,
        },
        isResidential: addresType === 'residential',
      };
      updateAddress.streetName =
        updateAddress.streetName && updateAddress.streetName != ''
          ? updateAddress.streetName.trim()
          : updateAddress.streetName;
      const addressStr =
        updateAddress.streetName +
        ',' +
        updateAddress.city +
        ',' +
        updateAddress.stateCode +
        ',' +
        'USA';
      this.validateAddressService.updateAddress(addressStr);
      this.addressService.setAddress(address);
      this.googlePlaceService.updateAddress(address);
      this.router.navigate([
        Constants.MY_INSURANCE,
        policyId,
        'change-address',
        addresType,
      ]);
    }
  }

  enrollInAutopay(policyNumber, actionType) {
    this.enrollEftEpayService.setPrevEftRoute(this.router.url);
    if (
      (this.policy &&
        this.policy['days_left_to_expire'] &&
        this.policy['days_left_to_expire'] <= 30 &&
        this.policy.policynumber.policyNumber.length === 6 &&
        this.policy.livoPolicy) ||
      this.policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      if (actionType === 'ENROLL') {
        this.router.navigate([
          '/billing',
          'paperless',
          'e-pay',
          policyNumber,
          'enroll',
        ]);
      } else {
        this.router.navigate([
          '/billing',
          'paperless',
          'e-pay',
          policyNumber,
          'edit-enroll',
        ]);
      }
    }
  }

  hideModalAction(e): void {
    if (e) {
      this.hideModal = !this.hideModal;
    }
  }

  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

  unEnrollEft(policyNumber, where) {
    if (
      (this.policy &&
        this.policy['days_left_to_expire'] &&
        this.policy['days_left_to_expire'] <= 30 &&
        this.policy.policynumber.policyNumber.length === 6 &&
        this.policy.livoPolicy) ||
      this.policy['isNewPolicy']
    ) {
      this.alertService.renewal('POLICY_UNDER_RENOVATION_MSG');
      window.scroll(0, 0);
    } else {
      const email = this.storageServiceObservablesService.getUserFromStorage();
      if (where == 'e-pay') {
        this.paperlessService
          .cancelPaperlessEPay(policyNumber, email)
          .subscribe(
            () => {
              if (policyNumber.length < 10) {
                this.alertService.error('EPAY_CANCEL');
              }
              this.reSync(email);
            },
            (error) => {
              if (error && error.status === 503) {
                this.errorRedirectionService.errorRedirectHandler(
                  error,
                  policyNumber
                );
              } else {
                this.errorRedirectionService.errorHandler(
                  error,
                  'PROBLEM_IN_REQUEST_PROCESSING'
                );
              }
            }
          );
      }
    }
  }

  reSync(email): void {
    this.policyDataService.clear();
    this.policyDetailsService.getPolicyDetailsByEmail(email).subscribe(
      () => {
        //do ntohing
      },
      (error) => {
        this.errorRedirectionService.errorRedirectHandler(error);
      }
    );
    window.scroll(0, 0);
  }
}
